import { render, staticRenderFns } from "./SelectMealVersion.vue?vue&type=template&id=38a8ac07&"
import script from "./SelectMealVersion.vue?vue&type=script&lang=ts&"
export * from "./SelectMealVersion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SelectMealVersion.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSimpleTable } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VProgressLinear,VSimpleTable})
